const listingPhotosLoader = async ({ injectReducer, dispatch, params }) => {
  const {
    default: reducer,
    getListingUploads
    // eslint-disable-next-line global-require
  } = require('../stores/listingPhotos');

  injectReducer(reducer);

  const { listingId } = params;

  return dispatch(getListingUploads({ listingId }));
};

export default listingPhotosLoader;
